module.exports = __webpack_public_path__ + "static/media/product_category_26.3db86abd.png";